export default function withTimeout(callback?: VoidFunction, time = 1000) {
  const timeout = setTimeout(() => {
    callback?.();
    clearTimeout(timeout);
  }, time);
}